import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 mx-auto rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
            <i className="ri-football-line text-4xl" />
          </div>
          <h1 className="mt-6 text-3xl md:text-4xl font-semibold text-foreground-950">
            404
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            页面走丢了，可能比赛已经结束或者链接有误。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/live"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 hover:bg-background-200 text-foreground-800 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-live-line" />
              查看直播
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}